import * as React from 'react';
import { LinkButton, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as styles from './NotFoundForLocationMobile.css';

export interface INotFoundForLocationMobileProps {
  url: string | undefined | null;
  openModal(): void;
}

export const NotFoundForLocationMobile: React.FC<INotFoundForLocationMobileProps> = ({ url, openModal }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <UIHeading2>У нас ещё нет посёлков в этом месте</UIHeading2>
      <div className={styles['description']}>
        <UIText1>Посмотрите все объекты поблизости или добавьте посёлок, если вы застройщик или его владелец</UIText1>
      </div>
      <div className={styles['actions']}>
        {url && (
          <div className={styles['catalog-link']}>
            <LinkButton fullWidth href={url} aria-label="Посмотреть все объекты">
              Посмотреть все объекты
            </LinkButton>
          </div>
        )}
        <button className={styles['add-village-btn']} aria-label="Добавить посёлок" onClick={openModal}>
          Добавить посёлок
        </button>
      </div>
    </div>
  );
};
